import React from "react";
import { ColorSwatch, Group, Tooltip, useMantineTheme } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { COLOR_OPTIONS } from "./constants";

const ColorPalette = ({ value, onChange, options = COLOR_OPTIONS }) => {
  const theme = useMantineTheme();
  return (
    <Group spacing="sm">
      {options.map((color) => {
        const isSelected = value === color;
        return (
          <Tooltip key={color} label={color} withArrow>
            <ColorSwatch
              component="button"
              type="button"
              color={theme.colors[color][6]}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange(color);
              }}
              style={{ cursor: "pointer" }}
              size={28}
            >
              {isSelected && <IconCheck size={16} color="#fff" />}
            </ColorSwatch>
          </Tooltip>
        );
      })}
    </Group>
  );
};

export default ColorPalette;
